import { render, staticRenderFns } from "./ErrorTrackingApplyPromotionViewPage.vue?vue&type=template&id=ed955db2&scoped=true&"
import script from "./ErrorTrackingApplyPromotionViewPage.vue?vue&type=script&lang=ts&"
export * from "./ErrorTrackingApplyPromotionViewPage.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorTrackingApplyPromotionViewPage.vue?vue&type=style&index=0&id=ed955db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed955db2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VIcon,VOverlay,VProgressCircular,VSimpleTable})
